// extracted by mini-css-extract-plugin
export default {"root":"style_root__GZmcM","title":"style_title__k4X92"};